import * as React from "react";
import Box from "@mui/material/Box";
import styles from "features/cancer-protection/step-1/StepOne.module.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { colors } from "app/providers/theme/colors-type";
import { CircularProgress, Link, TextField, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CustomButton from "shared/custom-button/CustomButton";
import { IStepOne } from "entities/cancer-protection/step-1/types/StepOne-interface";
import cancerBanner from "../../../../../public/images/cancerBanner.png";
import ModalWidget from "shared/modal/Modal";
import InfoIcon from "@mui/icons-material/Info";
import ArticleIcon from "@mui/icons-material/Article";

interface IInsuredBirthDateProps {
  formState: Record<string, any>;
  errors: Record<string, string>;
  handleDateChange: (
    fieldName: keyof IStepOne
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur: (
    fieldName: keyof IStepOne
  ) => (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  risksArray: Array<{ name: string; tooltip: React.ReactNode }>;
  handleNextStep: () => void;
  isLoadingPrograms: boolean;
  windowWidth: number;
}

export const InsuredBirthDate: React.FC<IInsuredBirthDateProps> = ({
  formState,
  errors,
  handleDateChange,
  handleBlur,
  risksArray,
  handleNextStep,
  isLoadingPrograms,
  windowWidth,
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const handleOpenModalRisks = () => {
    setIsModalOpen((prevState) => !prevState);
  };

  return (
    <Box className={styles.desktopContainer}>
      <Box className={styles.infoBox}>
        <Box className={styles.leftBox}>
          <Box className={styles.info}>
            <h4>
              Страховые риски{" "}
              <span onClick={handleOpenModalRisks}>
                <InfoOutlinedIcon />
              </span>
            </h4>
            <p>
              Диагностика и лечение злокачественных новообразований{" "}
              <span>(в т.ч. злокачественные новообразования in Situ)</span>
            </p>
            <p>трансплантация костного мозга</p>
          </Box>
          <Box className={styles.risksList}>
            {risksArray.map((item, index) => (
              <Box key={index} className={styles.riskBox}>
                <span className={styles.checkIcon}>
                  <CheckCircleIcon />
                </span>
                <p>{item.name}</p>
              </Box>
            ))}
          </Box>
        </Box>
        <Box className={styles.rightBoxImg}>
          <img src={cancerBanner} alt="banner" />
        </Box>
        <ModalWidget
          open={isModalOpen}
          handleClose={handleOpenModalRisks}
          title=""
          closeIconPosition="right"
          widthProps={windowWidth < 700 ? 300 : 650}
        >
          <>
            <Box className={styles.modalDesc}>
              <h4>Временная франшиза</h4>
              <p>
                Диагностика и лечение злокачественных новообразований{" "}
                <span>90 дней с даты начала срока страхования</span>
              </p>
              <p>
                Tрансплантация костного мозга{" "}
                <span>180 дней с даты начала срока страхования</span>
              </p>
            </Box>
            {risksArray.map((item, index) => (
              <Box key={index} className={styles.riskBoxAll}>
                <p className={styles.riskTitle}>{item.name}</p>
                {item.tooltip}
              </Box>
            ))}
          </>
        </ModalWidget>
      </Box>
      <Box className={styles.declorationBox}>
        <h4>Важные условия по состоянию здоровья</h4>
        <Box className={styles.declorationLink}>
          <ArticleIcon />
          <Link
            href="https://hr-dms.ugsk.ru/%D0%94%D0%B5%D0%BA%D0%BB%D0%B0%D1%80%D0%B0%D1%86%D0%B8%D1%8F%20%D0%BE%20%D1%81%D0%BE%D1%81%D1%82%D0%BE%D1%8F%D0%BD%D0%B8%D0%B8%20%D0%B7%D0%B4%D0%BE%D1%80%D0%BE%D0%B2%D1%8C%D1%8F_%D0%B4%D0%BB%D1%8F%20%D0%BE%D0%BD%D0%BA%D0%BE%D1%81%D1%82%D1%80%D0%B0%D1%85%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F.pdf"
            target="_blank"
            rel="noopener noreferrer"
            underline="always"
          >
            Декларация о состоянии здоровья
          </Link>
        </Box>
      </Box>
      <Box className={styles.formBox}>
        <h4>Возраст застрахованного</h4>
        <p>Укажите дату рождения того, кого хотите застраховать</p>
        <Box className={styles.colorBox}>
          <span className={styles.icon}>
            <InfoIcon />
          </span>
          <p>
            В рамках договора можно застраховать только одного застрахованного.{" "}
            <br /> Возраст застрахованного от 1 года до 70 лет. <br />{" "}
            Застрахованным может быть только гражданин РФ.
          </p>
        </Box>
        <Box className={styles.flexBox}>
          <TextField
            name="InsuredBirthDate"
            label="Дата рождения"
            variant="outlined"
            value={formState.InsuredBirthDate}
            onChange={handleDateChange("InsuredBirthDate")}
            placeholder="дд.мм.гггг"
            onBlur={handleBlur("InsuredBirthDate")}
            error={!!errors.InsuredBirthDate}
            helperText={errors.InsuredBirthDate}
          />
          {isLoadingPrograms ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            <CustomButton
              title="Расчитать"
              handleClick={handleNextStep}
              textColor="white"
              backgroundColor={colors.primary}
              width="150px"
              gap="10px"
              borderRadius="4px"
              padding="3px"
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
